module.exports = __webpack_public_path__ + "img/c03_buildingstartechdamascussteel_Normal_ua.9f03c96d.webp";